import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useRosaResultContext } from '../context';
import { Title } from '@/components/Typography';
import * as S from './styles';

export function RequiredElementsList() {
	const {
		rosaResult: { required }
	} = useRosaResultContext();

	const colors = ['#17A93B', '#F0AE00', '#E80707'];

	return (
		<Row justify="start" gutter={[8, 8]} hidden={required?.length === 0}>
			<Col xs={24}>
				<Title level={3}>{I18n.get('Required elements')}</Title>
			</Col>
			<Col xs={24}>
				<Row gutter={[0, 15]}>
					{required?.map((element: any) => (
						<Col span={24} key={element.id}>
							<S.RequiredElementRow>
								<S.ElementNameCol xs={8}>
									<strong>{I18n.get(element.name)}</strong>
								</S.ElementNameCol>
								<S.ElementActionCol xs={10} lg={10} xxl={11}>
									<strong>{I18n.get('Action')}:</strong> {I18n.get(element.action)}
								</S.ElementActionCol>
								<S.ElementScorePriorityCol xs={4} lg={4} xxl={3}>
									<strong>{I18n.get('Priority')}:</strong>
								</S.ElementScorePriorityCol>
								<S.ElementScorePriorityCol
									style={{ color: '#fff', backgroundColor: colors[element.priority] }}
									xs={2}
								>
									<strong>{element.priority}</strong>
								</S.ElementScorePriorityCol>
							</S.RequiredElementRow>
						</Col>
					))}
				</Row>
			</Col>
		</Row>
	);
}
